<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit, invalid }">
      <form @submit.prevent="handleSubmit(saveMember)">
        <v-card>
          <card-header :title="title" icon="menu" color="primary" variant="gradient"></card-header>
          <v-card-text>
            <div class="d-flex flex-column">
              <div v-for="(field, index) in fields" :key="index">
                <h4 class="card-title">{{ field.label }}</h4>

                <div class="d-flex flex-wrap">
                  <div v-for="(element, index) in field.elements" :key="index" class="field-wrapper">
                    <label class="sub-label">{{ element.label }}</label>

                    <validation-provider :name="element.label" :rules="element.rule" v-slot="{ errors }">
                      <v-text-field v-model="data[element.field]" :placeholder="element.placeholder"
                        :readonly="element.readonly" :error-messages="errors" outlined dense class="mt-2">
                        <template v-slot:append>
                          <v-icon v-if="errors.length" color="error">mdi-close</v-icon>
                          <v-icon v-else color="success">mdi-check</v-icon>
                        </template>
                      </v-text-field>
                    </validation-provider>
                  </div>
                </div>
              </div>

              <div class="text-right mt-4">
                <custom-button @click="saveMember" type="submit" :disabled="invalid" label="저장" color="primary"
                  size="lg" gradient rounded></custom-button>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import CardHeader from '@/components/cards/CardHeader.vue';
import { extend } from "vee-validate";
import { required, email, alpha, numeric } from "vee-validate/dist/rules";
import CustomButton from '@/components/common/buttons/CustomButton.vue';

/** 검증 항목 */
extend("required", { ...required });
extend("email", { ...email });
extend("alpha", { ...alpha });
extend("numeric", { ...numeric });

export default {
  name: "EditProfileForm",
  components: {
    CardHeader,
    CustomButton,
  },
  data() {
    return {
      data: this.member,
    };
  },
  props: {
    title: {
      type: String,
      required: false,
      default: ""
    },
    icon: {
      type: String,
      required: false,
      default: "menu"
    },
    button: {
      type: Object,
      required: false,
      default() {
        return { name: "완료", action: null };
      }
    },
    fields: {
      type: Array,
      required: true,
      default() {
        return [];
      }
    },
    member: {
      type: Object,
      required: true,
      default: () => ({
        idx: null,
        name: null,
        name_eng: null,
        member_type: null,
        personal_info: null,
        phone: null,
        country: null,
        email: null,
        organization: null,
        department: null,
        position: null,
      }),
    },
  },
  methods: {
    saveMember() {
      this.$emit("save-member", this.data);
    },
  },
};
</script>

<style scoped>
.card-title {
  font-weight: bold;
  color: #565656;
}

.sub-label {
  color: #FFAC11;
  font-weight: 400;
  font-size: medium;
  display: block;
}

.text-right {
  display: flex;
  justify-content: flex-end;
}

.field-wrapper {
  flex: 1;
  min-width: 250px;
  margin-right: 10px;
}
</style>
